/** @jsx isolateComponent */

import { css } from '@emotion/core';
import { Fragment } from 'react';

import { isolateComponent } from '@zapier/common-utils';
import { DateTime } from '@zapier/date';
import { Link, Margin, Text } from '@zapier/design-system';
import { Price } from '@zapier/design-system-revenue';

const valueTextStyles = css`
  font-weight: 400;
  white-space: nowrap;
`;

const getChargeDateText = (
  amount: number,
  offerEndDate: Date | null | undefined
) =>
  offerEndDate ? (
    <span>
      On <DateTime date={offerEndDate} />, you’ll be charged{' '}
      <Price>{amount}</Price>/month. Downgrade to a Free plan at any time before
      then and you won't be charged.
    </span>
  ) : (
    <span>
      After the offer period ends, you'll be charged <Price>{amount}</Price>
      /month. Downgrade to a Free plan at any time before the offer period ends
      and you won't be charged.
    </span>
  );

type Props = {
  destinationPlanAmount: number;
  destinationPlanName: string;
  maxUses: number;
  offerEndDate: Date;
  totalCost: number;
};

export const IntroPricingOfferModalView = ({
  destinationPlanAmount,
  destinationPlanName,
  maxUses,
  offerEndDate,
  totalCost,
}: Props) => (
  <Fragment>
    <Text tag="h1" textAlign="center" type="header800">
      Get {maxUses} months of {destinationPlanName} for{' '}
      <Price>{totalCost}</Price>{' '}
      <span css={valueTextStyles}>
        (<Price>{destinationPlanAmount * maxUses}</Price> value)
      </span>
    </Text>

    <Margin margin="20px 0">
      <Text tag="p" textAlign="center" type="bodyText900">
        Pay just <Price>{totalCost}</Price> for {maxUses} months of the{' '}
        <Link href="/app/billing/plans" target="_blank">
          {destinationPlanName} plan
        </Link>
        . {getChargeDateText(destinationPlanAmount, offerEndDate)}
      </Text>
    </Margin>
  </Fragment>
);
